(() => {

    // Block Name
    const blockName = 'testimonials';

    // Variables
    let method = 'front';
    if ( document.querySelector('body') == null || document.querySelector('body').classList.contains('wp-admin') ) {
        method = 'wp-admin';
    }
    // -- end

    // Custom methods

    // -- end

    // Init blocks
    const initializeBlock = (block) => {
        if (block[0] !== undefined ) block = block[0].querySelector(`.block-${blockName}`);
        if ( block === false || block === null ) return;

        // Block Code Here
        const settings = {
            direction: 'horizontal',
            slidesPerView: 3,
            loop: true,
            pagination: {
                el: '.fz-slider-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + ' fz-slider-pagination--element"></span>';
                },
            },
            // // watchOverflow: true,
            // // autoplay: {
            // //     delay: 6000,
            // // },
            // speed: 1000,
            breakpoints: {
                // when window width is >= 640px
                320: {
                    slidesPerView: 1,
                    // watchOverflow: true,
                },
                920: {
                    slidesPerView: 3,
                    // watchOverflow: true,
                },
            },

            // navigation: {
            //     nextEl: '.logotypes-slider--next',
            //     prevEl: '.logotypes-slider--prev',
            // },
        }

        const slider = new Swiper ('.testimonials-slider', settings);

    };

    // Get all blocks
    const getBlocks = () => {
        let blocks = document.querySelectorAll(`.block-${blockName}`);
        if ( blocks.length > 0 ) {
            blocks.forEach( (block) => {
                initializeBlock(block);
            });
        }
    };

    // Frontend
    document.addEventListener("DOMContentLoaded", getBlocks);

    // Acf Init
    window.addEventListener('load', (event) => {
        if (window.acf) {
            getBlocks();

            // Add update block action for ACF
            window.acf.addAction(`render_block_preview/type=${blockName}`, initializeBlock);
        }

    });

})();
